import { combineReducers } from '@reduxjs/toolkit';
import { loginReducer } from "./LoginReducer";
import { errorReducer } from "./ErrorReducer"; 
import { formatDIReducer } from "./FormatDIReducer";  
import filtersVehiclesReducer from './filtersVehiclesSlice.jsx'; 
import filtersVehiclesTrailersReducer from './filtersVehiclesTrailersSlice.jsx'; 

import filtersStoresReducer from './filtersStoresSlice.jsx'; 
import filtersEmployeesReducer from './filtersEmployeesSlice.jsx'; 
import filtersShippingsReducer from './filtersShippingsSlice.jsx';
import filtersRegistersReducer from './filtersRegistersSlice.jsx';
import filtersContractsReducer from './filtersContractsSlice.jsx';
import filtersCNTReducer from './filtersNTSlice.jsx';
import filtersFormDIReducer from './filtersFormDISlice'; 
import filtersReceivedEmailsReducer from './filtersReceivedEmailsSlice'; 
import filtersSentEmailsReducer from './filtersSentEmailsSlice'; 
import filtersSentInicidentssReducer from './filtersSentInicidentsSlice';
import filtersDriversReducer from './filtersDriversSlice.jsx'; 
import filtersArticlesReducer from './filtersArticlesSlice.jsx';
import filtersSHEETReducer from './filtersSHEETSlice.jsx';
import filtersPurchaseDeliveryReducer from './filtersPurchaseDeliverySlice';
import paginationArticlesReducer from './paginationArticlesSlice';
import paginationDriversReducer from './paginationDriversSlice';
import paginationVehiclesReducer from './paginationVehiclesSlice';
import paginationVehiclesTrailersReducer from './filtersVehiclesTrailersSlice';
import paginationStoresReducer from './paginationStoresSlice';
import paginationEmployeesReducer from './paginationEmployeesSlice';
import paginationShippingsReducer from './paginationShippingsSlice';
import paginationRegistersReducer from './paginationRegistersSlice';
import paginationContractsReducer from './paginationContractsSlice';
import paginationCNTReducer from './paginationNTsSlice';
import paginationFormDIReducer from './paginationFormDISlice';
import paginationReceivedEmailsReducer from './paginationReceivedEmailsSlice';
import paginationSentEmailsReducer from './paginationSentEmailsSlice';
import paginationSentIncidentsReducer from './paginationSentInicidentsSlice';
import paginationPurchaseDeliveryReducer from './paginationPurchaseDeliverySlice';
import paginationSHEETReducer from './paginationSHEETSlice';

import loadingReducer from './loadingSlice.jsx';
import userDefaultReducer from './userDefaultSlice.jsx';

const rootReducer = combineReducers({
  loginUser: loginReducer,
  loadError: errorReducer, 
  formatDIUser:formatDIReducer, 
  filtersVehicles: filtersVehiclesReducer,
  filtersVehiclesTrailers: filtersVehiclesTrailersReducer,
  filtersStores: filtersStoresReducer,
  filtersEmployees: filtersEmployeesReducer,
  filtersDrivers: filtersDriversReducer,
  filtersShippings: filtersShippingsReducer,
  filtersRegisters: filtersRegistersReducer,
  filtersContracts: filtersContractsReducer,
  filtersNTs: filtersCNTReducer,
  filtersFormDI: filtersFormDIReducer,
  filtersReceivedEmails: filtersReceivedEmailsReducer,
  filtersSentEmails: filtersSentEmailsReducer,
  filtersSentIncidents: filtersSentInicidentssReducer,
  filtersArticles: filtersArticlesReducer,
  filtersSHEET: filtersSHEETReducer,
  filtersPurchaseDelivery: filtersPurchaseDeliveryReducer,

  pagination: paginationPurchaseDeliveryReducer,
  paginationSHEET: paginationSHEETReducer,
  paginationArticles: paginationArticlesReducer,
  paginationVehicles: paginationVehiclesReducer,
  paginationVehiclesTrailers:paginationVehiclesTrailersReducer,
  paginationStores: paginationStoresReducer,
  paginationEmployees: paginationEmployeesReducer,
  paginationDrivers: paginationDriversReducer,
  paginationShippings: paginationShippingsReducer,
  paginationRegisters: paginationRegistersReducer,
  paginationContracts: paginationContractsReducer,
  paginationNTs: paginationCNTReducer,
  paginationFormDI: paginationFormDIReducer,
  paginationReceivedEmails: paginationReceivedEmailsReducer,
  paginationSentEmails: paginationSentEmailsReducer,
  paginationSentIncidents: paginationSentIncidentsReducer,
  
  loading: loadingReducer,
  userDefault: userDefaultReducer
  
});

export default rootReducer;
